<template>
  <div class="container-fluid py-4 bg-light min-vh-content">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3"
    >
      <div>
        <h4 class="font-weight-bold text-dark mb-1">Ouvidoria</h4>

        <p class="text-muted mb-0">
          Utilize este canal para registrar manifestações, sugestões,
          reclamações ou elogios.
        </p>
      </div>

      <div class="d-flex mt-3 mt-md-0">
        <router-link
          to="/dashboard/admin/central/home"
          class="btn btn-outline-secondary btn-sm mr-2"
        >
          Voltar
        </router-link>
      </div>
    </div>

    <div class="card border-0 shadow-sm">
      <div class="card-body p-0 position-relative">
        <div
          v-if="loading"
          class="position-absolute bg-white border rounded shadow-sm px-3 py-2 d-flex align-items-center loading-box"
        >
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          >
            <span class="sr-only">Carregando...</span>
          </div>

          <span class="ml-2 text-muted"> Carregando formulário... </span>
        </div>

        <iframe
          class="w-100 border-0 ouvidoria-frame"
          :src="embeddedFormUrl"
          marginheight="0"
          marginwidth="0"
          @load="loading = false"
        >
          Carregando…
        </iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Ouvidoria",

  data() {
    return {
      loading: true,
      externalFormUrl:
        "https://docs.google.com/forms/d/e/1FAIpQLSeAdU_xDreY5w-K1pARjPjHQuDEeBju83AewFSwWiclzkfCsg/viewform",
    };
  },

  computed: {
    embeddedFormUrl() {
      return `${this.externalFormUrl}?embedded=true`;
    },
  },
};
</script>

<style scoped>
.min-vh-content {
  min-height: calc(100vh - 64px);
}

.ouvidoria-frame {
  display: block;
  height: calc(100vh - 165px);
  min-height: 680px;
  background: #fff;
}

.loading-box {
  top: 1rem;
  left: 1rem;
  z-index: 10;
}

@media (max-width: 768px) {
  .ouvidoria-frame {
    height: calc(100vh - 220px);
    min-height: 620px;
  }
}
</style>
